import React from 'react';
import { useSelector } from 'umi';
import { mobilePageConfig } from './mobilePageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { nightingalePageConfig } from './nightingalePageConfig';
import { pcPageConfig } from './pcPageConfig';
import { casualPageConfig } from './casualPageConfig';

const reqParams = '/comparisonAnalysis/dateComparison';
const DateComparison = () => {
  const dataFrame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile';
  });
  const pageMap: any = {
    mobile: mobilePageConfig,
    pc: pcPageConfig,
    pc_inflexion: nightingalePageConfig,
    casual: casualPageConfig
  };
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame]}/>
    </>
  );
};

export default DateComparison;